import React from 'react';

import HeaderApp from 'components/Header/HeaderApp';
import Bottom from 'components/Bottom';
import PageTitle from 'components/_base/PageTitle';

import ContentQuery from './ContentQuery';

const App = () => {
  return (
    <>
      <HeaderApp />
      <PageTitle title="Consulta" />
      <hr />
      <ContentQuery />
      <Bottom />
    </>
  );
};

export default App;
